export default "__VITE_ASSET__BoQPUJi2__"